import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { IEstatusJson } from "src/app/features/authmanagement/models/IEstatusJson";
import { IUserLoginRequest } from "src/app/features/authmanagement/models/IUserLoginRequest";
import { NewPasswordModel } from "src/app/features/authmanagement/models/new-password.model";
import { SendRecoveryPasswordMailRequest } from "src/app/features/authmanagement/models/SendRecoveryPasswordMailRequest.model";


@Injectable({
  providedIn: "root",
})
export class AuthAPIService implements IApiBase {
  configUrl: string;

  constructor(
    private http: HttpClient
  ) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  Login(usuarioLogin: IUserLoginRequest): any {
      console.log("/api/authmanagement/login/");
      return this.http.post<IEstatusJson>(
        this.configUrl + "/api/authmanagement/login",
        usuarioLogin
      );
    }


  getRefreshToken(token: any) {
    console.log("/api/authmanagement/refreshToken/");
    return this.http.post<IEstatusJson>(
      this.configUrl + "/api/authmanagement/refreshToken",
      token,
      {}
    );
  }

  resetPassword(objResetPassword: NewPasswordModel){
      return this.http.post<IEstatusJson>(environment.host + '/api/AuthManagement/ResetPassword', objResetPassword);
    }
  
    sendRecoveryPasswordEmail(objSendPasswordRecoveryMail: SendRecoveryPasswordMailRequest){
      return this.http.post<IEstatusJson>(environment.host + '/api/AuthManagement/SendRecoveryPasswordEmail', objSendPasswordRecoveryMail);
    }

    public UpdateClientId(client: any) {
      console.log("/api/AuthManagement/UpdateClientId/");
      return this.http.post<IEstatusJson>( this.configUrl + "/api/AuthManagement/UpdateClientId", client);
    }
  
    public UpdateDefaultClientId() {
      console.log("/api/AuthManagement/UpdateDefaultClientId/");
      return this.http.get<IEstatusJson>( this.configUrl + "/api/AuthManagement/UpdateDefaultClientId");
    }
}
